module.exports = __webpack_public_path__ + "img/Emoticon-JustOK.1d2feb3c.svg";